export enum ServiceType {
  InformationalService = 'is',
  TransactionalService = 'ts',
}
